<div class="innerpage-fullwithbanner">
  <ng-container>
    <h2 class="bighead" *ngIf="!isInEditMode">Add New Property</h2>
    <h2 class="bighead" *ngIf="isInEditMode">Edit Property Details</h2>
  </ng-container>
  <ul class="bread-crumbs">
    <li>
      <a href="#" [routerLink]="['/']">
        Home
        <span>|</span>
      </a>
    </li>
    <li>
      <a (click)="onBreadCrumbClick();">{{this.prevPage}}<span>|</span></a>
    </li>
    <!--<li *ngIf="this.authService.Admin()">
      <a (click)="onBreadCrumbClick();">View-Portfolio<span>|</span></a>
    </li>
    <li *ngIf="!this.authService.Admin() && IsmyPortfolio"><a href="#" [routerLink]="['/market-snapshot']" [queryParams]="{ UserGuid: UserGuid,opentab: '2'}">My Portfolio<span>|</span></a></li>
    <li *ngIf="!this.authService.Admin() && !IsmyPortfolio"><a href="#" [routerLink]="['/market-snapshot']" [queryParams]="{ UserGuid: UserGuid,opentab: '2'}">{{selectedPortfolioName}}'s Portfolio<span>|</span></a></li>-->
    <ng-container>
      <li *ngIf="!isInEditMode">Add New Property</li>
      <li *ngIf="isInEditMode">Edit Property</li>
    </ng-container>
  </ul>
</div>
<form [formGroup]="propForm" autocomplete="off" #formDir="ngForm" name="form" class="property-form">
  <div class="container container-lg section-margin">
    <!--<div *ngIf="ShowDuplicates" class="duplicate-pro-alert modal-content deletemodal">-->
    <!--<h6 class="displayvalue" [hidden]="duplicatesFound">Checking for duplicates...</h6>
    <h6 class="displayvalue" [hidden]="!duplicatesFound">Duplicate(s) Identified!</h6>
    <div class="text-right margin-top-20" [hidden]="!duplicatesFound">
      <button class="btn btn-lg btn-border" (click)="showDuplicates(DuplicateProperties,'panlestyle');">View Duplicates</button>
    </div>-->
    <!--</div>-->
    <div class="border-div no-shadow">
      <h2 class="mainhead">
        <span class="text">Tenant Name</span>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group autocomplete-design">
            <label class="form-label">
              Tenant
              <span class="star">*</span>
              <label class="custom-checkbox" style="float:right; height:10px">
                <input formControlName="chkNewTenantInfo" #newTenantInfo [(ngModel)]="model.IsNewTenant" id="checkbox12" type="checkbox" (click)="checkNewTenant(newTenantInfo.checked)">
                <i class="helper"></i> New Tenant
              </label>
            </label>
            <!--<ng2-completer [hidden]="model.IsNewTenant" [class.error-input]="getnullableInput('TenantName')" [(ngModel)]="model.TenantName" [textSearching]="model.TenantName" [maxChars]="90" [datasource]="dataService"
                 formControlName="txtTenantName" (selected)="onTenantSelect($event)" [overrideSuggested]="true" [minSearchLength]="0" (blur)="onTenantBlur($event)"></ng2-completer>-->
            <ng-select [items]="dataService$ | async"
                       bindLabel="TenantName"
                       bindValue="TenantName"
                       formControlName="txtTenantName"
                       [hideSelected]="true"
                       [loading]="loading"
                       (change)="onTenantSelect($event)"
                       [typeahead]="dataServiceInput$"
                       [minTermLength]="0"
                       [(ngModel)]="model.TenantName" [class.error-input]="getnullableInput('TenantName')" [ngModelOptions]="{standalone: true}" *ngIf="!model.IsNewTenant">
            </ng-select>
            <input type="text" maxlength="100" [class.error-input]="getnullableInput('TenantNameText')" *ngIf="model.IsNewTenant" class="form-control" formControlName="txtTenantNameFreeText" [(ngModel)]="model.TenantNameText" />

            <div>
              <p class="redtext" *ngIf="!model.TenantName && isSubmitted && !model.IsNewTenant">
                Tenant name is required
              </p>
              <p class="redtext" *ngIf="model.TenantName==' ' && isSubmitted && !model.IsNewTenant">
                The value cannot be only white spaces
              </p>
              <p class="redtext" *ngIf="!model.TenantNameText && isSubmitted && model.IsNewTenant">
                Tenant name is required
              </p>
              <p class="redtext" *ngIf="model.TenantName==' ' && isSubmitted && model.IsNewTenant">
                The value cannot be only white spaces
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label clearfix">
              Property Status
            </label>
            <label class="select" *ngIf="disablePropertyStatus">
              <select class="form-control" name="lstPropertyStatus" [attr.disabled]="true" formControlName="lstPropertyStatus" [(ngModel)]="model.PropertyStatusId" (ngModelChange)="onPorpertyStatusChange($event)" (change)="openSolidDetails(templateSolidDetails,'panlestyle sold-modal',model.PropertyStatusId)">
                <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
            <label class="select" *ngIf="!disablePropertyStatus">
              <select class="form-control" name="lstPropertyStatus" formControlName="lstPropertyStatus" [(ngModel)]="model.PropertyStatusId" (ngModelChange)="onPorpertyStatusChange($event)" (change)="openSolidDetails(templateSolidDetails,'panlestyle sold-modal',model.PropertyStatusId)">
                <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label hidden-xs hidden-sm">&nbsp;</label>
            <div role="group" class="form-radio">
              <div class="radio radio-inline">
                <label>
                  <input id="Franchisee" type="radio" value="Franchisee" [checked]="!isCorporate" name="rdFranchisee" formControlName="rdFranchisee" (change)="onFranchiseChange('fr')">
                  <i class="helper"></i>Franchisee
                </label>
              </div>
              <div class="radio radio-inline">
                <label>
                  <input id="Corporate" type="radio" value="Corporate" [checked]="isCorporate" name="rdFranchisee" formControlName="rdFranchisee" (change)="onFranchiseChange('cr')">
                  <i class="helper"></i>Corporate
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

          <div class="form-group">
            <label class="form-label">
              Guarantor
              <label class="custom-checkbox" style="float:right; height:10px">
                <input formControlName="chkGurantorInfo" #newGuarantor [(ngModel)]="model.IsNewGuarantor" id="checkbox12" (click)="checkNewGuarantor(newGuarantor.checked)" type="checkbox"> New Guarantor
                <i></i>
              </label>
            </label>
            <label class="select" *ngIf="!model.IsNewGuarantor">
              <select class="form-control" formControlName="drpGuarantor" (change)="onGuarantorChanges();" [(ngModel)]="model.GuarantorId">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let guarantor of guarantorList" [(ngValue)]="guarantor.Id">{{guarantor.Name}}</option>
              </select>
              <i></i>
            </label>
            <input type="text" maxlength="100" *ngIf="model.IsNewGuarantor" class="form-control" formControlName="txtGuarantorNameText" [(ngModel)]="model.GuarantorName" />

          </div>
        </div>

      </div>
      <div class="row" role="group" aria-labelledby="_rating">

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">S&amp;P Rating</label>
            <label class="select">
              <select formControlName="lstSandP" [(ngModel)]="model.SPRatingId" class="form-control ">
                <option [value]="null">Select</option>
                <option *ngFor="let item of sprRatingList" [(ngValue)]="item.id">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Moody's Rating</label>
            <label class="select">
              <select formControlName="lstMoodyRating" [(ngModel)]="model.MoodyRatingId"
                      class="form-control ">
                <option [value]="null">Select</option>
                <option *ngFor="let item of moodysRatingList" [(ngValue)]="item.id">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group ">
            <label class="form-label">Fitch Rating</label>
            <label class="select">
              <select formControlName="fitchRating" [(ngModel)]="model.FitchRatingId"
                      class="form-control">
                <option [value]="null">Select</option>
                <option *ngFor="let item of fitchRatingList" [(ngValue)]="item.id">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Number of Units
            </label>
            <input type="text" [class.error-input]="getnullableInput('NoOfUnits')" mask="99999" formControlName="txtNumberOfUnits" [min]="isFranchise ? 1 : 0"
                   [(ngModel)]="model.NoOfUnits" class="form-control ">
            <div *ngIf="(txtNumberOfUnits.invalid && isSubmitted)||(txtNumberOfUnits.invalid && (txtNumberOfUnits.dirty || txtNumberOfUnits.touched))">
              <p class="redtext" *ngIf="txtNumberOfUnits.errors.required">Enter number of franchicies</p>
              <p class="redtext" *ngIf="txtNumberOfUnits.errors.min">Number of units must be greater than 0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div">
      <div class="floatinghead clearfix">
        <h2 class="mainhead">
          <span class="text">Location</span>
        </h2>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Street Address
              <span class="star">*</span>
            </label>
            <input [(ngModel)]="model.Address" [class.error-input1]="getnullableInput('Address')" #addresstext (change)="onDuplicateChecking();" formControlName="txtAddress" name="txtAddress" required maxlength="190" type="text" class="form-control" (ngModelChange)="onStreetAddressChange()">
            <div *ngIf="(txtAddress.invalid && isSubmitted)||(txtAddress.invalid && (txtAddress.dirty || txtAddress.touched))">
              <p class="redtext" *ngIf="txtAddress.errors.spaceOnly">
                The value cannot be only white spaces
              </p>
              <p class="redtext" *ngIf="txtAddress.errors.required">
                Address is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              State
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" formControlName="lstState" [class.error-input]="getnullableInput('StateId')" (change)="bindCity()" [(ngModel)]="model.StateId">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let state of statesList" [(ngValue)]="state.Id">{{state.Name}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstState.invalid && isSubmitted)||(lstState.invalid && (lstState.dirty || lstState.touched))">
              <p class="redtext" *ngIf="lstState.errors.required">
                State is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              City
              <span class="star">*</span>
            </label>
            <label class="select">
              <select formControlName="lstCity" [class.error-input]="getnullableInput('CityId')" [(ngModel)]="model.CityId" class="form-control " (change)="callZipChange($event)">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let city of citiesList" [(ngValue)]="city.Id">{{city.Name}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstCity.invalid && isSubmitted) ||(lstCity.invalid && (lstCity.dirty || lstCity.touched))">
              <p class="redtext" *ngIf="lstCity.errors.required">
                City is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Zip
              <span class="star">*</span>
            </label>
            <input formControlName="txtZip" (change)="callZipChange($event)" [class.error-input]="getnullableInput('Zip')" [(ngModel)]="model.Zip" maxlength="10" mask="00000" required
                   type="text" class="form-control ">

            <div *ngIf="(txtZip.invalid && isSubmitted) || (txtZip.invalid && (txtZip.dirty || txtZip.touched))">
              <p class="redtext" *ngIf="txtZip.errors.required">
                Zip is required
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-none">

      </div>
      <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
        <h5 class="mr-auto margin-bottom-0">
          <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
            <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
          </i>
          <span>Select Street Address From Google Maps Dropdown For Best Results</span>
        </h5>
      </div>
      <div class="mapdiv">
        <input type="hidden" formControlName="lat" [(ngModel)]="model.Latitude">
        <input type="hidden" formControlName="lon" [(ngModel)]="model.Longitude">
        <div #gmap style="width:100%;height:350px"></div>
      </div>
    </div>
    <div class="border-div">
      <div class="floatinghead floatinghead-xs clearfix">
        <h2 class="mainhead">
          <span class="text">Property Info</span>
        </h2>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Year Built
              <span class="star">*</span>
            </label>
            <input type="text" mask="0000" formControlName="txtYearBuilt" [class.error-input]="getnullableInput('YearBuilt')" [min]="1850" [max]="today.getFullYear()" [required]="model.PropertyStatusId!=6906" [(ngModel)]="model.YearBuilt"
                   class="form-control ">
            <div *ngIf="(txtYearBuilt.invalid && isSubmitted) || (txtYearBuilt.invalid && (txtYearBuilt.dirty || txtYearBuilt.touched))">
              <p class="redtext" *ngIf="txtYearBuilt.errors.required">
                Year of built is required
              </p>
              <p class="redtext" *ngIf="txtYearBuilt.errors.min">The year of built must be greater or equal to 1850</p>
              <p class="redtext" *ngIf="txtYearBuilt.errors.max">
                The year cannot be greater than {{today.getFullYear()}}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Renovated
            </label>
            <input type="text" mask="0000" [class.error-input]="getnullableInput('Renovated')" formControlName="txtRenovated" ng-minlength="4" [min]="model.YearBuilt" [(ngModel)]="model.Renovated"
                   class="form-control">
            <div *ngIf="(txtRenovated.invalid && isSubmitted) || (txtRenovated.invalid && (txtRenovated.dirty || txtRenovated.touched))">
              <p class="redtext" *ngIf="txtRenovated.errors.minlength">
                Please enter a valid year
              </p>
              <p class="redtext" *ngIf="(model.Renovated.length==4) && (txtRenovated.errors.minValue)">
                <!--The year cannot be less than {{model.YearBuilt}}-->
                The renovated year cannot be less than year of built
              </p>

              <p class="redtext" *ngIf="txtRenovated.errors.max">
                The year cannot be greater than {{today.getFullYear()}}
              </p>

            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Property Type
              <span class="star">*</span>
            </label>
            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstPropertyType" [class.error-input]="getnullableInput('PropertyTypeList')"
                            [(ngModel)]="model.PropertyTypeList" placeholder="Select" (ngModelChange)="bindSubCategories($event)" multiple>
                  @if (model?.PropertyTypeList.length > 1) {
                  <mat-select-trigger (click)="$event.stopPropagation()">
                    <span>{{ model?.PropertyTypeList.length }} items selected</span>
                  </mat-select-trigger>
                  }
                  @for (item of propertyTypesList; track item) {
                  <mat-option [value]="item.id" class="multi-dropdown-item">{{item.name}}</mat-option>
                  }
                  @if (propertyTypesList.length === 0) {
                  <mat-option class="matoptionnodata" disabled>
                    Nothing found...
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="(lstPropertyType.invalid && isSubmitted)">
              <p class="redtext" *ngIf="lstPropertyType.errors.required">
                Property type is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Subcategory
              <span class="star" *ngIf="model.PropertyStatusId==6906">*</span>
            </label>
            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstSubcatgeories" [class.error-input]="getnullableInput('PropertyTypeSubcategoryList')"
                            [(ngModel)]="model.PropertyTypeSubcategoryList" placeholder="Select" (selectionChange)="bindSubCategories($event.value)" multiple>
                  @if (model?.PropertyTypeSubcategoryList?.length > 1) {
                  <mat-select-trigger>
                    <span>{{ model?.PropertyTypeSubcategoryList?.length }} items selected</span>
                  </mat-select-trigger>
                  }
                  @for (item of subCategoriesList; track $index) {
                  <mat-option [value]="item.id" class="multi-dropdown-item">{{item.name}}</mat-option>
                  }
                  @if (subCategoriesList.length === 0) {
                  <mat-option class="matoptionnodata" disabled>
                    Nothing found...
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="(lstSubcatgeories.invalid && isSubmitted)">
              <p class="redtext" *ngIf="lstSubcatgeories.errors.required">
                Subcategory is required
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Building SF
              <span class="star">*</span>
            </label>
            <div class="textbox-with-4character textbox-with-btn">
              <input type="text" inputmode="numeric" [class.error-input]="getnullableInput('BuildingSize')" class="form-control" formControlName="txtBuildingSF" min="1" [min]="1" maxlength="18" dropSpecialCharacters="false" mask="separator.10.2" thousandSeparator=","
                     [(ngModel)]="model.BuildingSize" (change)="validationService.onlyDecimal($event);" (keyup)="updatePSF()">
              <span class="rightlabel">SQ FT</span>
            </div>
            <div *ngIf="(txtBuildingSF.invalid && isSubmitted)||(txtBuildingSF.invalid && (txtBuildingSF.dirty || txtBuildingSF.touched))">
              <p class="redtext" *ngIf="txtBuildingSF.errors.required">
                Building size is required
              </p>
              <p class="redtext" *ngIf="txtBuildingSF.errors.min">
                Building size should be greater than 0
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Land (AC)
              <span class="star" *ngIf="model.PropertyStatusId==6906">*</span>
            </label>
            <div class="textbox-with-4character textbox-with-btn">
              <input min="0.001" [min]="0.001" type="text" mask="999999999.99" [class.error-input]="getnullableInput('Land')" [dropSpecialCharacters]="false" formControlName="txtland" name="land" [(ngModel)]="model.Land"
                     class="form-control " (change)="validationService.onlyDecimal($event);">
              <span class="rightlabel">acre</span>
            </div>
            <div *ngIf="(txtland.invalid && isSubmitted)||(txtland.invalid && (txtland.dirty || txtland.touched))">
              <p class="redtext" *ngIf="txtland.errors.required">
                Land (AC) is required
              </p>
              <p class="redtext" *ngIf="txtland.errors.min">
                Land area should be greater than 0
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div">
      <h2 class="mainhead">
        <span class="text">Lease Info</span>
        <button [disabled]="disableAddEditHistoryButton" type="button" class="btn  btn-circle btn-green margin-bottom pull-right"
                aria-controls="dropdown-basic" *ngIf="authService.Admin()||authService.SuperAdmin()" (click)="openSalesHistoryAdd('hdnLeasingHistory')" tooltip="Add New Leasing History" triggers="mouseenter:mouseleave"
                placement="left">
          <i aria-hidden="true" class="fa fa-plus icon"></i>
        </button>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Lease Structure
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" [class.error-input]="getnullableInput('LeaseStructureId')" formControlName="lstLeaseStructure" [(ngModel)]="model.LeaseStructureId">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="str.id" *ngFor="let str of leaseStructureList">{{str.description}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstLeaseStructure.invalid && isSubmitted) ||(lstLeaseStructure.invalid && (lstLeaseStructure.dirty || lstLeaseStructure.touched))">
              <p class="redtext" *ngIf="lstLeaseStructure.errors.required">
                Lease structure is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Ownership Type
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" [class.error-input]="getnullableInput('OwnershipTypeId')" formControlName="lstOwnershipType" [(ngModel)]="model.OwnershipTypeId">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="item.id" *ngFor="let item of ownershipList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstOwnershipType.invalid && isSubmitted)|| (lstOwnershipType.invalid && (lstOwnershipType.dirty || lstOwnershipType.touched))">
              <p class="redtext" *ngIf="lstOwnershipType.errors.required">
                Ownership type is required
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-{{ this.model.PropertyForId === 601 ? '6' : '3'}} col-md-{{ this.model.PropertyForId === 601 ? '6' : '3'}} col-sm-12 col-xs-12">
          <label class="bluelabel">Rent</label>
          <div class="row">
            <div class="col-lg-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-md-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-sm-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Rent / NOI
                  <span class="star">*</span>
                </label>
                <div class="textbox-with-btn-left">
                  <input formControlName="txtNOI" [class.error-input]="getnullableInput('NOI')" [(ngModel)]="model.NOI" [min]="0" required="required" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"
                         dropSpecialCharacters="false" class="form-control " (keyup)="updateCapRate('NOI')" value="{{model.NOI|number}}" (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="leftlabel">$</span>
                </div>
                <div *ngIf="(txtNOI.invalid && isSubmitted)||(txtNOI.invalid && (txtNOI.dirty || txtNOI.touched))">
                  <p class="redtext" *ngIf="txtNOI.errors.required">
                    Rent / NOI is required
                  </p>
                  <p class="redtext" *ngIf="txtNOI.errors.min">
                    Rent / NOI value should be greater than 0
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Lease (Date)</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Commencement
                  <span class="star">*</span>
                </label>
                <div class="textbox-date">
                  <input type="text" maxlength="10" [class.error-input]="getnullableInput('LeaseCommencementDate')" name="txtCommencement" formControlName="txtCommencement" (change)="onLeaseDatesChange($event)"
                         [min]="model.YearBuilt" [(ngModel)]="model.LeaseCommencementDate" required="required"
                         class="form-control" bsDatepicker (ngModelChange)="propertyRentTermsFielsChange()">
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
                <div *ngIf="(txtCommencement.invalid && isSubmitted)||(txtCommencement.invalid && (txtCommencement.dirty || txtCommencement.touched))">
                  <p class="redtext" *ngIf="txtCommencement.errors.required">
                    Commencement date is required
                  </p>
                  <p class="redtext" *ngIf="txtCommencement.errors.minYear">
                    Commencement date should be after the year of built
                  </p>
                  <p class="redtext" *ngIf="txtCommencement.errors.maxDate">
                    Commencement date should be in the past
                  </p>
                  <p class="redtext" *ngIf="model.LeaseCommencementDate =='Invalid Date'">
                    Please enter a valid date
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Expiration
                  <span class="star">*</span>
                </label>
                <div class="textbox-date">
                  <input type="text" maxlength="10" [min]="model.YearBuilt" [class.error-input]="getnullableInput('LeaseExpiration')" formControlName="txtExpiration" (change)="onLeaseDatesChange($event)"
                         [(ngModel)]="model.LeaseExpiration" name="txtExpiration" required="required" class="form-control"
                         bsDatepicker (ngModelChange)="propertyRentTermsFielsChange()">
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
                <div *ngIf="(txtExpiration.invalid && isSubmitted)||(txtExpiration.invalid && (txtExpiration.dirty || txtExpiration.touched))">
                  <p class="redtext" *ngIf="txtExpiration.errors.required">
                    Lease expiration date is required
                  </p>
                  <p class="redtext" *ngIf="txtExpiration.errors.minDate">
                    Lease expiration date should be after the commencement date
                  </p>
                  <p class="redtext" *ngIf="model.LeaseExpiration =='Invalid Date'">
                    Please enter a valid date
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              RPSF
              <span class="star" *ngIf="model.PropertyStatusId!=6906">*</span>
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" inputmode="numeric" disabled [class.error-input]="getnullableInput('LeasePricePSF')" class="form-control" formControlName="txtPSF" min="1" [min]="1" maxlength="21" dropSpecialCharacters="false" mask="separator.10.2" thousandSeparator=","
                     [(ngModel)]="model.LeasePricePSF" (change)="validationService.onlyDecimal($event);">
              <span class="leftlabel">$</span>
            </div>
            <div *ngIf="(txtPSF.invalid && isSubmitted)||(txtPSF.invalid && (txtPSF.dirty || txtPSF.touched))">
              <p class="redtext" *ngIf="txtPSF.errors.required">
                RPSF is required
              </p>
              <p class="redtext" *ngIf="txtPSF.errors.min">
                RPSF value should be greater than 0
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">
            Term (in years)
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Original
                  <span class="star" *ngIf="model.PropertyStatusId!=6906">*</span>
                </label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input type="hidden" formControlName="txtOriginalHdn" [(ngModel)]="model.OriginalLeaseTerm" />
                  <input type="text" mask="9999" disabled formControlName="txtOriginal" [class.error-input]="getnullableInput('OriginalLeaseTerm')" min="0" [value]="[model.LeaseExpiration | yearsGapBetweenDates: model.LeaseCommencementDate]"
                         class="form-control ">
                  <!-- <span class="rightlabel">Years</span> -->
                </div>
                <div *ngIf="(txtOriginal.invalid && isSubmitted)||(txtOriginal.invalid && (txtOriginal.dirty || txtOriginal.touched))">
                  <p class="redtext" *ngIf="txtOriginal.errors.required">
                    Original term is required
                  </p>
                  <p class="redtext" *ngIf="txtOriginal.errors.min">
                    Original term should be greater than 0
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Remaining</label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input type="text" disabled="disabled" [value]="[model.LeaseExpiration | propRemainingTerm: model.LeaseCommencementDate]"
                         class="form-control">
                  <!-- <span class="rightlabel">Years</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Escalation</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Percentage</label>
                <div class="textbox-with-btn textbox-with-2character">
                  <input formControlName="txtEscalationPercentage" [class.error-input]="getnullableInput('RentEscalationPercentage')" [max]="100" [min]="0" [(ngModel)]="model.RentEscalationPercentage" type="text"
                         [dropSpecialCharacters]="false" mask="999.99" class="form-control" (change)="validationService.onlyDecimal($event);" (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="rightlabel">%</span>
                </div>
                <div *ngIf="(txtEscalationPercentage.invalid && isSubmitted)||(txtEscalationPercentage.invalid && (txtEscalationPercentage.dirty || txtEscalationPercentage.touched))">
                  <p class="redtext" *ngIf="txtEscalationPercentage.errors.max">
                    Escalation percentage cannot be greater than 100
                  </p>
                  <p class="redtext" *ngIf="txtEscalationPercentage.errors.min">
                    Escalation percentage cannot be less than 0
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Period</label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input formControlName="txtEscalationYrs" [class.error-input]="getnullableInput('RentEscalationPeriod')" min="0" [min]="0" [(ngModel)]="model.RentEscalationPeriod" type="text" mask="9999"
                         class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="rightlabel">Year(s)</span>
                </div>
                <div *ngIf="(txtEscalationYrs.invalid && isSubmitted)||(txtEscalationYrs.invalid && (txtEscalationYrs.dirty || txtEscalationYrs.touched))">
                  <p class="redtext" *ngIf="txtEscalationYrs.errors.min">
                    Escalation period cannot be less than 0
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row margin-bottom-20">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Option</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Number</label>
                <input formControlName="txtOptionNumber" min="0" [(ngModel)]="model.OptionNumber" type="text" mask="999999999" class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Length</label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input formControlName="txtOptionLength" min="0" [(ngModel)]="model.OptionLength" type="text" mask="9999" class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="rightlabel">Year(s)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

        </div>
      </div>
      <div style="display:none;">
        <div class="floatinghead clearfix">
          <h2 class="mainhead">
            <span class="text">NOI / Rent Schedule</span>
          </h2>
        </div>
        <div>
          <app-rent-term-table (updateLoadStatus)="updateLoadStatus($event)" (rentTerm)="saveRentTerm($event)" [propertyId]="this.model.Id" [InitialLoad]="InitialLoad" [rentTermsAutoCalc]="retnTermAutoCalcValue" [rentTerms]="rentTerms" [PropertyRentTerms]="model.PropertyRentTerm" [IsEditAllowed]="true"></app-rent-term-table>
        </div>
      </div>
      <div>
      </div>

      <div>
      </div>
    </div>
    <div class="border-div">
      <h2 class="mainhead">
        <span class="text">Acquisition Info</span>
      </h2>
      <div class="row">
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Acquisition Price
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtAcquisitionPrice" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.AcquisitionPrice"
                     class="form-control " value="{{model.AcquisitionPrice|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>

          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Acquisition Cap Rate
            </label>
            <div>
              <div class="textbox-with-btn textbox-with-2character">
                <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" [class.error-input]="getnullableInput('AcquisitionCapRate')" type="text" mask="999.99" formControlName="txtAcquisitionCapRate" [dropSpecialCharacters]="false" [(ngModel)]="model.AcquisitionCapRate" class="form-control" (change)="validationService.onlyDecimal($event);">
                <span class="rightlabel">%</span>
              </div>
              <div *ngIf="(txtAcquisitionCapRate.invalid && isSubmitted)||(txtAcquisitionCapRate.invalid && (txtAcquisitionCapRate.dirty || txtAcquisitionCapRate.touched))">
                <p class="redtext" *ngIf="txtAcquisitionCapRate.errors.max">
                  Acquisition Cap Rate cannot be greater than 100
                </p>
                <p class="redtext" *ngIf="txtAcquisitionCapRate.errors.min">
                  Acquisition Cap Rate cannot be less than 0
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="border-div" *ngIf="model.PropertyStatusId!=6906">
      <div class="floatinghead clearfix">
        <h2 class="mainhead">
          <span class="text">Pricing Info</span>
        </h2>
        <!--<div class="rightcheckbox" *ngIf="model.PropertyStatusId!=6906">
          <label class="custom-checkbox margin-right-15" for="checkbox18">
            <input readonly="readonly" formControlName="chkUnpriced" (click)="UnpricedClick($event)" [(ngModel)]="model.Unpriced" id="checkbox18" type="checkbox"> Unpriced
            <i></i>
          </label>
        </div>-->
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Asking Price
              <span class="star" *ngIf="model.PropertyStatusId!=6906">*</span>
            </label>
            <div class="textbox-with-btn-left" *ngIf="!model.Unpriced">
              <input type="text" [class.error-input]="getnullableInput('AskingPrice')" formControlName="txtAskingPrice" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" (keyup)="updateCapRate('AskingPrice');model.AutoCalcPrice=false" [(ngModel)]="model.Price"
                     class="form-control " value="{{model.Price|toNumber|number}}">
              <span class="leftlabel">$</span>
              <div *ngIf="(txtAskingPrice.invalid && isSubmitted)|| (txtAskingPrice.invalid && (txtAskingPrice.dirty || txtAskingPrice.touched))">
                <p class="redtext" *ngIf="txtAskingPrice.errors.required">
                  Asking Price is required
                </p>
              </div>
            </div>
            <div *ngIf="model.Unpriced">
              <input type="text" disabled formControlName="txtUnpricedText" [(ngModel)]="model.UnpricedText"
                     class="form-control">
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              {{capratetext}}
              <label class="custom-checkbox " style="float:right; height:10px" for="chkCalcCAP">
                <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" #inputCalcCAP id="chkCalcCAP" formControlName="chkAutoCalcCapRate" (click)="reCalcRates(2,inputCalcCAP.checked)" type="checkbox" [(ngModel)]="model.AutoCalcCapRate"> Auto Calc <!--Cap Rate-->
                <i></i>
              </label>
            </label>
            <div *ngIf="!model.Unpriced">
              <div class="textbox-with-btn textbox-with-2character">
                <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" [class.error-input]="getnullableInput('CapRate')" (keyup)="model.AutoCalcCapRate=false" type="text" mask="999.99" formControlName="txtCapRate" [dropSpecialCharacters]="false" [(ngModel)]="model.CapRate" class="form-control" (change)="validationService.onlyDecimal($event);">
                <span class="rightlabel">%</span>
              </div>
              <div *ngIf="(txtCapRate.invalid && isSubmitted)||(txtCapRate.invalid && (txtCapRate.dirty || txtCapRate.touched))">
                <p class="redtext" *ngIf="txtCapRate.errors.max">
                  Cap Rate cannot be greater than 100
                </p>
                <p class="redtext" *ngIf="txtCapRate.errors.min">
                  Cap Rate cannot be less than 0
                </p>
              </div>
            </div>
            <div *ngIf="model.Unpriced" class="form-group">
              <input type="text" disabled formControlName="txtCapRateText" [(ngModel)]="model.CapRateText"
                     class="form-control">
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="border-div">
      <h2 class="mainhead">
        <span class="text">Debt Info</span>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Loan Amount
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtLoanAmount" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.LoanAmount"
                     class="form-control " value="{{model.LoanAmount|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Interest Rate
            </label>
            <div>
              <div class="textbox-with-btn textbox-with-2character">
                <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" [class.error-input]="getnullableInput('InterestRate')" type="text" mask="999.99" formControlName="txtInterestRate" [dropSpecialCharacters]="false" [(ngModel)]="model.InterestRate" class="form-control" (change)="validationService.onlyDecimal($event);">
                <span class="rightlabel">%</span>
              </div>
              <div *ngIf="(txtInterestRate.invalid && isSubmitted)||(txtInterestRate.invalid && (txtInterestRate.dirty || txtInterestRate.touched))">
                <p class="redtext" *ngIf="txtInterestRate.errors.max">
                  Interest Rate cannot be greater than 100
                </p>
                <p class="redtext" *ngIf="txtInterestRate.errors.min">
                  Interest Rate cannot be less than 0
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Amortization
            </label>
            <label class="select">
              <select class="form-control" name="lstAmortization" formControlName="lstAmortization"
                      [(ngModel)]="model.Amortization">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="item.id" *ngFor="let item of AmortizationFieldList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Origination Date
            </label>
            <div class="textbox-date">
              <input type="text" maxlength="10" name="txtOrginationDate" [class.error-input]="getnullableInput('OrginationDate')" formControlName="txtOrginationDate"
                     [(ngModel)]="model.OrginationDate" class="form-control" bsDatepicker>
              <i class="icofont icofont-ui-calendar icon"></i>
            </div>
            <div *ngIf="(txtOrginationDate.invalid && isSubmitted)||(txtOrginationDate.invalid && (txtOrginationDate.dirty || txtOrginationDate.touched))">
              <p class="redtext" *ngIf="model.OrginationDate =='Invalid Date'">
                Please enter a valid date
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Maturity Date
            </label>
            <div class="textbox-date">
              <input type="text" maxlength="10" name="txtMaturityDate" [class.error-input]="getnullableInput('MaturityDate')" formControlName="txtMaturityDate"
                     [(ngModel)]="model.MaturityDate"
                     class="form-control" bsDatepicker>
              <i class="icofont icofont-ui-calendar icon"></i>
            </div>
            <div *ngIf="(txtMaturityDate.invalid && isSubmitted)||(txtMaturityDate.invalid && (txtMaturityDate.dirty || txtMaturityDate.touched))">
              <p class="redtext" *ngIf="model.MaturityDate =='Invalid Date'">
                Please enter a valid date
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Prepay
            </label>
            <label class="select">
              <select class="form-control" name="lstPrepay" formControlName="lstPrepay"
                      [(ngModel)]="model.PrePay">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="item.lookupValue" *ngFor="let item of PrepayList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Assumable
            </label>
            <label class="select">
              <select class="form-control" name="lstAssumable" formControlName="lstAssumable"
                      [(ngModel)]="model.Assumable">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="item.lookupValue" *ngFor="let item of AssumableList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Lender
            </label>
            <div>
              <div class="textbox-with-btn textbox-with-2character">
                <input type="text" formControlName="txtLender" maxlength="50" [(ngModel)]="model.Lender" class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" [hidden]="true">
      <h2 class="mainhead">
        <span class="text">Expense Info</span>
      </h2>
      <div class="row">
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Expenses
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtExpenses" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.Expenses"
                     class="form-control " value="{{model.Expenses|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Reimbursements
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtExpenseReimbursement" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.ExpenseReimbursement"
                     class="form-control " value="{{model.ExpenseReimbursement|toNumber|number}}">
              <span class="leftlabel">$</span>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" [hidden]="true">
      <h2 class="mainhead">
        <span class="text">Property Tax</span>
      </h2>
      <div class="row">
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Tax Paid
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtTax" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.Tax"
                     class="form-control " value="{{model.Tax|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Reimbursements
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtTaxReimbursement" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.TaxReimbursement"
                     class="form-control " value="{{model.TaxReimbursement|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" [hidden]="true">
      <h2 class="mainhead">
        <span class="text">Insurance Info</span>
      </h2>
      <div class="row">
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Insurance Paid
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtInsurance" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.Insurance"
                     class="form-control " value="{{model.Insurance|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Reimbursements
            </label>
            <div class="textbox-with-btn-left">
              <input type="text" formControlName="txtInsuranceReimbursement" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.InsuranceReimbursement"
                     class="form-control " value="{{model.InsuranceReimbursement|toNumber|number}}">
              <span class="leftlabel">$</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="border-div">
      <h2 class="mainhead">
        <span class="text">Documents &amp; Images</span>
      </h2>
      <!--<div class="margin-bottom-20 clearfix" *ngIf="authService.Admin()">
        <div class="rightcheckbox ">
          <label class="custom-checkbox margin-right-20" for="checkbox13">
            <input formControlName="chkOfferMemoReqApproval" [(ngModel)]="model.OfferMemoReqApproval" id="checkbox13" type="checkbox">Offering Memorandum access requires approval
            <i></i>
          </label>

          <label class="custom-checkbox  margin-right-20" for="checkbox14">
            <input formControlName="chkDueDiligenceReqApproval" [(ngModel)]="model.DueDiligenceReqApproval" id="checkbox14" type="checkbox">Due Diligence access requires approval
            <i></i>
          </label>

          <label class="custom-checkbox " for="checkbox15">
            <input formControlName="chkConfidentialityAgreement" [(ngModel)]="model.ConfidentialityAgreement" id="checkbox15" type="checkbox">Confidentiality Agreement Required
            <i></i>
          </label>
        </div>
      </div>-->
      <div class="om-dd-check-wrapper margin-bottom-20 d-felx">
        <div style="display:inline-block;" class="inline-block rightcheckbox">
          <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
            <li class="transition margin-bottom-10">
              <div class="list-filter-div d-flex flex-wrap-wrap">
                <div class="inner-div  d-flex flex-wrap-wrap">
                  <label>
                    Offering Memorandum:
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox13">
                    <input formControlName="chkOfferMemoReqApproval" [(ngModel)]="model.OfferMemoReqApproval" id="checkbox13" type="checkbox">Requires Approval
                    <i></i>
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox14">
                    <input formControlName="chkConfidentialityAgreement" [(ngModel)]="model.ConfidentialityAgreement" id="checkbox15" type="checkbox">Requires Confidentiality Agreement
                    <i></i>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="display:inline-block;" class="inline-block rightcheckbox">
          <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
            <li class="transition">
              <div class="list-filter-div">
                <div class="inner-div  d-flex flex-wrap-wrap">
                  <label>
                    Due Diligence:
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox15">
                    <input formControlName="chkDueDiligenceReqApproval" [(ngModel)]="model.DueDiligenceReqApproval" id="checkbox14" type="checkbox">Requires Approval
                    <i></i>
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox14">
                    <input formControlName="chkDDConfidentialityAgreement" [(ngModel)]="model.DDConfidentialityAgreement" id="checkbox15" type="checkbox">Requires Confidentiality Agreement
                    <i></i>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="floatinghead clearfix">
        <h3 class="bluelabel">Documents</h3>

        <div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Documents" placement="left">
          <input type="file" (change)="onNewFileUpload($event)" multiple #propDoc class="fileupload">
          <span class="icofont icofont-upload-alt icon"></span>
        </div>
        <!--<file-upload (selectedFilesListEmitter)=onNewFileUpload($event) [uploadType]="fileUploadType" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles"></file-upload>
        <label class="alert-danger">{{errorMessageForLOI}}</label>-->
      </div>
      <div>
        pa
        <p class="commonpara">
          <i container="body" class="userpermissiontooltip margin-right-5" aria-hidden="true" placement="right">
            <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
          </i>
          <span>Allowed file types: .PDF</span>
        </p>
      </div>
      <div class="table-responsive margin-bottom-20">
        <table class="table basictable">
          <thead>
            <tr>
              <th style="width:50px">#</th>
              <th>Document Title</th>
              <th>Category</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of propertyDocuments; let i = index;">
              <td>
                <p>{{i + 1}}</p>
              </td>
              <td>
                <p>{{doc.Name}}</p>
              </td>
              <td>
                <label class="select">
                  <select [(ngModel)]="doc.CategoryId" [formControlName]="'cmbDocCat' + getDocId(i)" class="form-control ">
                    <option [ngValue]="null">Select</option>
                    <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                  </select>
                  <i></i>
                </label>
                <div *ngIf="(propForm.get('cmbDocCat' + getDocId(i)).invalid && isSubmitted) || (propForm.get('cmbDocCat' + getDocId(i)).invalid && (propForm.get('cmbDocCat' +getDocId(i)).dirty || propForm.get('cmbDocCat' +getDocId(i)).touched))">
                  <p class="redtext" *ngIf="propForm.get('cmbDocCat' +getDocId(i)).errors.required">
                    Document category is required
                  </p>
                </div>
              </td>
              <td>
                <a class="view" *ngIf="doc.Url != null && doc.Url.length > 0" href={{doc.Url}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                   ng-reflect-placement="top" triggers="hover">
                  <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                </a>
                <a href="javascript:void(0);" (click)="onRemoveDocument(i)" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="propertyDocuments.length === 0">
              <td colspan="4" style="text-align: center; font-weight: normal; color: gray">

                <div class="nodata">
                  <i class="icofont icofont-warning icon"></i>
                  <p>No Documents Added</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--new upload style-->
      <!--<ul class="imglisting informationupload">
          <li class="addnew">
              <input   type="file" (change)="onNewFileUpload($event)" multiple #propDoc>
              <span class="icofont icofont-upload-alt"></span>
              <p>Click here to Upload Documents</p>
          </li>
      </ul>-->
      <!--new upload style ends-->

      <h3 class="bluelabel margin-bottom-15">Property Images</h3>
      <div class="floatinghead clearfix">
        <p class="commonpara">
          (For connectivity below the Wifi speed(like 4G&3G), upload photos with less than 3-4MB size to reduce the upload
          time duration.)
        </p>
        <div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Images" placement="left">
          <input #propImage class="fileupload" (change)="onNewImageUpload($event)" multiple type="file">
          <span class="icofont icofont-upload-alt icon"></span>
        </div>
      </div>
      <div class="table-responsive margin-bottom-20">
        <table class="table basictable imglisting">
          <thead>
            <tr>
              <th style="width:50px">#</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th>Alt Text</th>
              <th>Caption</th>
              <th>Description</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of propertyImages; let i = index;" class="draggable"
                [class.active]="draggedOverIndex == i">
              <td>
                <p>{{i+1}}</p>
              </td>
              <td class="image-div">
                <div class="img-check" [ngClass]="(i == 0 && isContainsIsDefault()) || file.IsDefault? 'active': ''">
                  <label class="custom-checkbox ">
                    <input type="radio" ondragover="return false" name="default" (click)="setAsDefault(file.Id,i)">
                    <i class="helper"></i>
                  </label>
                </div>
                <div class="margin-top-15"><div>Default</div></div>
              </td>
              <td draggable="true"
                  (dragover)="allowDrop($event, i)"
                  (dragstart)="onDragStart(i)"
                  (drop)="onDrop($event,i)" class="img_drag">
                <span>
                  <img [src]="file.Url" style="width:75px;height:53px;" />
                </span>
              </td>
              <td>
                <input class="form-control" ondragover="return false" type="text" maxlength="100" [formControlName]="'txtalText'+getImageId(i)" [(ngModel)]="file.AlText" />
              </td>
              <td>
                <input class="form-control" ondragover="return false" type="text" [formControlName]="'txtCaption'+getImageId(i)" maxlength="100" [(ngModel)]="file.Caption" />
                <input class="form-control" type="hidden" [formControlName]="'txtDisplayOrder'+getImageId(i)" />
              </td>
              <td>
                <textarea class="form-control" ondragover="return false" style="padding:0px 15px !important;" [formControlName]="'txtLongDescription'+getImageId(i)" maxlength="500" [(ngModel)]="file.Description"></textarea>
              </td>
              <td>
                <a href="javascript:void(0);" ondragover="return false" (click)="onRemoveImage(file.Id,i)" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="propertyImages.length === 0">
              <td colspan="7" style="text-align: center; font-weight: normal; color: gray">

                <div class="nodata">
                  <i class="icofont icofont-warning icon"></i>
                  <p>No Image Added</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" style="margin-bottom:35px !important;">
      </div>
      <!--<h3 class="bluelabel margin-bottom-10">Property Images</h3>
      <p class="commonpara">
        (For connectivity below the Wifi speed(like 4G &3G) , upload photos with less than 3-4mb size to reduce the upload
        time duration.)
      </p>
      <ul class="imglisting">
        <li *ngFor="let file of propertyImages; let i = index">
          <span class="img-download" (click)="getFile(file.Url, file.Name)">
            <img [src]="file.Url" />
            <i class="fa fa-download" aria-hidden="true"></i>
          </span>

          <div class="img-check" [ngClass]="(i == 0 && isContainsIsDefault()) || file.IsDefault? 'active': ''">
          <input type="radio"  name="default" (click)="setAsDefault(file.Id,i)" />
      <i></i>Set as Default
          <label class="custom-checkbox ">
            <input type="radio" name="default" (click)="setAsDefault(file.Id,i)">
            <i class="helper"></i>Default
          </label>
        </div>
        <a href="javascript:void(0);" (click)="onRemoveImage(file.Id,i)" class="remove" triggers="hover" ng-reflect-placement="top" ng-reflect-tooltip="Remove" placement="top" tooltip="Remove">
          <i class="icofont icofont-close" aria-hidden="true"></i>
        </a>
      </li>
      <li class="addnew add-new-img" tooltip="Upload New Image">
        <label>
          <input #propImage (change)="onNewImageUpload($event)" multiple type="file">
          icofont-plus
          <span class="icofont icofont-upload-alt"></span>
            <p>Upload New</p>
          </label>
        </li>
      </ul>-->
      <h3 class="bluelabel margin-bottom-10">Videos</h3>
      <div class="row">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Paste your vimeo video URL here</label>
            <input formControlName="txtVideoUrl" [class.error-input]="getnullableInput('VideoUrl')" [(ngModel)]="model.VideoUrl" class="form-control " type="text">
            <div *ngIf="(txtVideoUrl.invalid && isSubmitted) || (txtVideoUrl.invalid && (txtVideoUrl.dirty || txtVideoUrl.touched))">
              <p class="redtext" *ngIf="txtVideoUrl.errors.vimeoUrl">
                Invalid Vimeo video url
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right margin-bottom-30">
      <button (click)="cancelSave()" class="btn btn-default btn-lg margin-bottom-10">Cancel</button>
      <button (click)="approveTenantGuarantor()" *ngIf="((model.TenantId==0||model.TenantId==null) || model.GuarantorName) && (authService.Admin()||authService.SuperAdmin())&&model.Id!=null&&model.Id>0&&model.PropertyStatusId != 6906" class="btn btn-success btn-lg margin-bottom-10">Approve Tenant/Guarantor</button>
      <button (click)="saveChanges(null,2)" *ngIf="!model.LiveListingId &&(authService.Admin()||authService.SuperAdmin())&&model.Id!=null&&model.Id>0&&model.PropertyStatusId != 6906" class="btn btn-success btn-lg margin-bottom-10">Save</button>
      <button (click)="saveChanges(ChangeUpdate,3)" class="btn btn-success btn-lg margin-bottom-10" *ngIf="(authService.Admin()||authService.SuperAdmin())&&model.Id!=null&&model.Id>0&&model.PropertyStatusId != 6906">Save & List</button>
      <button (click)="saveChanges(ChangeUpdate,3)" *ngIf="((!model.LiveListingId&&!authService.Admin()&&!authService.SuperAdmin())||!model.LiveListingId&&(authService.Admin()||authService.SuperAdmin())&&model.PropertyStatusId == 6906)" class="btn btn-success btn-lg margin-bottom-10">Save Property</button>
      <button (click)="saveChanges(ChangeUpdate,3)" *ngIf="!isInEditMode&&!model.LiveListingId&&(authService.Admin()||authService.SuperAdmin())&&model.PropertyStatusId != 6906" class="btn btn-success btn-lg margin-bottom-10">Save Property</button>
    </div>

  </div>
</form>
<!-- <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCkUOdZ5y7hMm0yrcCQoCvLwzdM6M8s5qk&libraries=places&callback=initAutocomplete"
    async defer></script> -->


<ng-template #ChangeUpdate>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">There were some updates on the property source site. Did we capture those in B+E?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="callSaveApiMethod(false)">NO</button>
      <button class="btn btn-lg btn-success" (click)="callSaveApiMethod(true)">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertyForSelection>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">This property will be listed for {{propertyFor}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="modalRefPropertyForSelection.hide()">OK</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertyForConfirmation>
  <div class="modal-body padding30">
    <div class="form-group" *ngIf="authService.Admin()||authService.SuperAdmin()">
      <h6 class="displayvalue">Are you sure you want to list {{ model.TenantName }} for {{propertyFor}} ? </h6>
    </div>
    <div class="form-group" *ngIf="!authService.Admin()&&!authService.SuperAdmin()">
      <h6 class="displayvalue">Are you sure you want to submit this {{isPortfolio ? 'portfolio' : 'property'}} for approval? </h6>
    </div>

    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="RemoveConfirm();">NO</button>
      <button class="btn btn-lg btn-success" *ngIf="authService.Admin()||authService.SuperAdmin()" (click)="saveMethod(ChangeUpdate)">YES</button>
      <button *ngIf="!authService.Admin()&&!authService.SuperAdmin()" class="btn btn-lg btn-success" (click)="saveMethod(ChangeUpdate)">Proceed</button>
    </div>
  </div>
</ng-template>



<ng-template #BrokerageBroker>
  <app-brokerage-broker-add [modalRef]="modalRef" [selectedBrokers]="selectedBrokers" [selectedBrokerage]="brokerageName" (addBroker)="addBroker($event);" (closeModal)="closeModalDataEntry($event)" [selectedBrokerageId]="brokerageId"></app-brokerage-broker-add>
</ng-template>

<ng-template #templateAutoCalcRentTerm>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Auto Calculate Rent Term?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide();setAutoCalcRentTermPreviousValue();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Entries will be lost when you check this option. Are you sure you want to proceed?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide();setAutoCalcRentTermPreviousValue();">No</button>
      <button class="btn btn-lg btn-primary" (click)="setAutoCalcRentTerm();modalRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #templateBrockerDelete>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Broker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRemoveBrockerRef.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete broker?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRemoveBrockerRef.hide();">No</button>
      <button class="btn btn-lg btn-primary" (click)="onRemoveBrokers(this.brockerIndex);modalRemoveBrockerRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #Duplicate>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">A property with the same tenant name and address exists in the application. Would you like to continue ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDuplicates.hide();">NO</button>
      <button class="btn btn-lg btn-success" (click)="saveMethodAfterDuplicateCheck(ChangeUpdate)">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #DuplicateProperties>
  <app-duplicate-properties [duplicatePropertyList]="duplicatePropertyList" [modalRef]="modalRefPrDuplicate"></app-duplicate-properties>
</ng-template>
<ng-template #templateSolidDetails>
  <app-sold-details (save)="addSalesDetails($event)" [property]="model" [currentSalesDetails]="currentSalesDetails" (close)="closeModal($event)"></app-sold-details>
</ng-template>


